"use client";

import { Alert, Card, Col, Row } from 'antd';
import data from 'public/meta.json';
import React from 'react';
import { PageWithLayout, CollapsiblePanel, MainLayout } from '@shesha-io/reactjs';
import { createStyles } from 'antd-style';
import {
  ENTERPRISE_HEADER_FORM_ID
} from '@/app-constants';

const useStyles = createStyles(({ css }) => ({
  alert: css`
    margin-bottom: 15px;
  `,
}));

const Home: PageWithLayout<{}> = () => {
  const { styles } = useStyles();
  return (
    <MainLayout noPadding headerFormId={ENTERPRISE_HEADER_FORM_ID}>
      <CollapsiblePanel header="Plugins">
        <Alert className={styles.alert} message="This is a list of plugins the boilerplate uses" type="info" />

        <Row style={{ flex: 1 }}>
          {(data?.plugins ?? []).map((plugin) => (
            <Col md={6} key={plugin.name} data-testid="container">
              <Card title={plugin.name}>{plugin.description}</Card>
            </Col>
          ))}
        </Row>
      </CollapsiblePanel>
    </MainLayout>
  );
};

export default Home;